import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
    MedicalPlanDataTypeEnum,
    TieredCoverageAmountModel,
    TieredCoverageModel,
    Tiers
} from '@genesis-frontend/genesis-utilities';
import { InsurancePlanCoverageAmount } from '@genesis-frontend/graphql';

@Component({
    selector: 'tiered-coverage',
    templateUrl: './tiered-coverage.component.html',
    styleUrls: ['./tiered-coverage.component.scss']
})
export class TieredCoverageComponent implements OnInit {

    @Input() insurancePlanCoverages: InsurancePlanCoverageAmount[] = [];
    tieredCoverage: TieredCoverageModel = {
        tierOne: undefined,
        tierTwo: undefined,
        tierThree: undefined
    };

    tiers: any = [];
    constructor(private translate: TranslateService) {}

    hasFamilyValues = false;
    hasIndividualValues = false;

    ngOnInit() {
        this.setupTieredCoverage();
    }

    setupTieredCoverage() {
        this.checkIndividualAndFamilyCoverage();

        const tierOneCoverages = this.getCoverageAmountsBasedOnNetwork(Tiers.Tier1);
        const tierTwoCoverages = this.getCoverageAmountsBasedOnNetwork(Tiers.Tier2);
        const tierThreeCoverages = this.getCoverageAmountsBasedOnNetwork(Tiers.Tier3);

        this.tieredCoverage.tierOne = this.getTieredNetworkCoverageAmounts(tierOneCoverages, this.translate.instant(Tiers.Tier1));
        this.tieredCoverage.tierTwo = this.getTieredNetworkCoverageAmounts(tierTwoCoverages, this.translate.instant(Tiers.Tier2));
        this.tieredCoverage.tierThree = this.getTieredNetworkCoverageAmounts(tierThreeCoverages, this.translate.instant(Tiers.Tier3));

        this.tiers = [this.tieredCoverage.tierOne, this.tieredCoverage.tierTwo, this.tieredCoverage.tierThree];
    }

    checkIndividualAndFamilyCoverage() {
        this.hasFamilyValues = this.getCoveragesBasedOnPlanLevel(this.insurancePlanCoverages, MedicalPlanDataTypeEnum.Family).length > 0;
        this.hasIndividualValues = this.getCoveragesBasedOnPlanLevel(this.insurancePlanCoverages, MedicalPlanDataTypeEnum.Individual).length > 0;
    }

    getCoverageAmountsBasedOnNetwork(network: string): InsurancePlanCoverageAmount[] {
        return this.insurancePlanCoverages.filter((coverage) => coverage.network === network);
    }

    getTieredNetworkCoverageAmounts(coverages: InsurancePlanCoverageAmount[], defaultLabel: string): TieredCoverageAmountModel | undefined {
        if (coverages.length === 0) {
            return undefined;
        }

        return {
            name: coverages[0].customLabel ?? defaultLabel,
            individual: this.getCoveragesBasedOnPlanLevel(coverages, MedicalPlanDataTypeEnum.Individual),
            family: this.getCoveragesBasedOnPlanLevel(coverages, MedicalPlanDataTypeEnum.Family)
        };
    }

    getCoveragesBasedOnPlanLevel(coverages: InsurancePlanCoverageAmount[], planLevel: string) {
        return coverages.filter((coverage) =>
            coverage.planLevel === planLevel && coverage.network !== MedicalPlanDataTypeEnum.OutOfNetwork
        ).sort((a, b) => a.coverage.length - b.coverage.length);
    }
}
